(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1MMdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14cfaddf7b657fa6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "whenGlobal", function () { return $14cfaddf7b657fa6$export$42a7c3ec3c3dde5a; });
$parcel$export(module.exports, "documentSignal", function () { return $14cfaddf7b657fa6$export$5b0c92123667125b; });
// Runs a block initializer on the frontend (once the DOM is ready) or after
// every ACF preview render in the editor. The initializer receives the root
// to search in and `{ isEditor }`.
function $14cfaddf7b657fa6$export$2e2bcd8739ae039(slug, init) {
    var acf = window.acf, wp = window.wp;
    if ((acf === null || acf === void 0 ? void 0 : acf.addAction) && (wp === null || wp === void 0 ? void 0 : wp.blocks)) {
        acf.addAction("render_block_preview/type=".concat(slug), function($block) {
            var root = ($block === null || $block === void 0 ? void 0 : $block.jquery) ? $block.get(0) : $block;
            if (root) init(root, {
                isEditor: true
            });
        });
        return;
    }
    var run = function() {
        return init(document, {
            isEditor: false
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
}
function $14cfaddf7b657fa6$export$42a7c3ec3c3dde5a(win, name, callback) {
    if (win[name]) {
        callback(win[name]);
        return;
    }
    win.addEventListener('load', function() {
        if (win[name]) callback(win[name]);
    }, {
        once: true
    });
}
function $14cfaddf7b657fa6$export$5b0c92123667125b(doc, key, instance) {
    var _instance_closest, _store_get;
    var store = doc.juniperBlockSignals || new Map();
    // eslint-disable-next-line no-param-reassign
    doc.juniperBlockSignals = store;
    var id = instance ? "".concat(key, ":").concat(((_instance_closest = instance.closest('[data-block]')) === null || _instance_closest === void 0 ? void 0 : _instance_closest.dataset.block) || '') : key;
    (_store_get = store.get(id)) === null || _store_get === void 0 ? void 0 : _store_get.abort();
    var controller = new AbortController();
    store.set(id, controller);
    return controller.signal;
}

});


var $1MMdM = parcelRequire("1MMdM");
var $f5b7a22d3d3cc261$var$esc = function(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};
function $f5b7a22d3d3cc261$var$initHeader(root, param) {
    var isEditor = param.isEditor;
    var siteHeader = root.querySelector('#site-header');
    if (!siteHeader || siteHeader.dataset.runtimeReady === 'true') return;
    siteHeader.dataset.runtimeReady = 'true';
    var doc = siteHeader.ownerDocument;
    var signal = (0, $1MMdM.documentSignal)(doc, 'header');
    var sticky = function() {
        var header = root.querySelector('#site-header');
        if (!header) return;
        var lastY = window.scrollY;
        window.addEventListener('scroll', function() {
            var y = window.scrollY;
            header.classList.toggle('is-scrolled', y > 30);
            if (y > lastY && y > 100) header.classList.add('is-hidden');
            else if (y < lastY) header.classList.remove('is-hidden');
            lastY = y;
        }, {
            passive: true
        });
    };
    var hamburger = function() {
        var burger = root.querySelector('#nav-toggle');
        var drawer = root.querySelector('#mobile-nav');
        var overlay = root.querySelector('.site-nav-overlay');
        if (!burger) return;
        var open = function() {
            burger.classList.add('is-active');
            burger.setAttribute('aria-expanded', 'true');
            burger.setAttribute('aria-label', 'Close menu');
            drawer === null || drawer === void 0 ? void 0 : drawer.classList.add('is-open');
            drawer === null || drawer === void 0 ? void 0 : drawer.setAttribute('aria-hidden', 'false');
            overlay === null || overlay === void 0 ? void 0 : overlay.classList.add('is-visible');
        };
        var close = function() {
            burger.classList.remove('is-active');
            burger.setAttribute('aria-expanded', 'false');
            burger.setAttribute('aria-label', 'Open menu');
            drawer === null || drawer === void 0 ? void 0 : drawer.classList.remove('is-open');
            drawer === null || drawer === void 0 ? void 0 : drawer.setAttribute('aria-hidden', 'true');
            overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove('is-visible');
        };
        burger.addEventListener('click', function() {
            return burger.classList.contains('is-active') ? close() : open();
        });
        overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener('click', close);
        doc.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') close();
        }, {
            signal: signal
        });
    };
    var search = function() {
        var _window_kcaData;
        var toggle = root.querySelector('#search-toggle');
        var modal = root.querySelector('#search-modal');
        var closeBtn = root.querySelector('#search-close');
        var clearBtn = root.querySelector('#search-clear');
        var overlay = root.querySelector('.search-modal__overlay');
        var input = root.querySelector('#search-input');
        var dropdown = root.querySelector('#search-dropdown');
        var resultsEl = root.querySelector('#search-results');
        var footerEl = root.querySelector('#search-footer');
        var footerLabel = root.querySelector('#search-footer-label');
        if (!toggle || !modal) return;
        var apiBase = window.kcaData && window.kcaData.restUrl ? window.kcaData.restUrl : '/wp-json/kca/v1/search';
        var _window_kcaData_siteUrl;
        var siteUrl = (_window_kcaData_siteUrl = (_window_kcaData = window.kcaData) === null || _window_kcaData === void 0 ? void 0 : _window_kcaData.siteUrl) !== null && _window_kcaData_siteUrl !== void 0 ? _window_kcaData_siteUrl : '';
        var open = function() {
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            overlay === null || overlay === void 0 ? void 0 : overlay.classList.add('is-visible');
            toggle.setAttribute('aria-expanded', 'true');
            input.focus();
        };
        var closeModal = function() {
            var wasOpen = modal.classList.contains('is-open');
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove('is-visible');
            toggle.setAttribute('aria-expanded', 'false');
            hideDropdown();
            if (wasOpen) toggle.focus();
        };
        var showDropdown = function() {
            dropdown && (dropdown.hidden = false);
        };
        var hideDropdown = function() {
            dropdown && (dropdown.hidden = true);
        };
        var updateFooter = function(q) {
            if (!footerEl || !footerLabel) return;
            footerLabel.textContent = 'Search for "'.concat(q, '"');
            var params = new URLSearchParams({
                s: q,
                post_type: 'product'
            });
            footerEl.href = "".concat(siteUrl, "/?").concat(params.toString());
        };
        var highlightSugg = function(label, q) {
            if (!q) return $f5b7a22d3d3cc261$var$esc(label);
            var lc = label.toLowerCase();
            var qc = q.toLowerCase();
            var idx = lc.indexOf(qc);
            if (idx === -1) return $f5b7a22d3d3cc261$var$esc(label);
            var pre = $f5b7a22d3d3cc261$var$esc(label.slice(0, idx));
            var match = $f5b7a22d3d3cc261$var$esc(label.slice(idx, idx + q.length));
            var post = $f5b7a22d3d3cc261$var$esc(label.slice(idx + q.length));
            return "".concat(pre).concat(match, "<strong>").concat(post, "</strong>");
        };
        var suggItem = function(s, q) {
            var href = $f5b7a22d3d3cc261$var$esc(s.link || '');
            var lbl = highlightSugg(s.label, q);
            var cls = 'search-modal__suggestion-item';
            return '<li><a href="'.concat(href, '" class="').concat(cls, '">').concat(lbl, "</a></li>");
        };
        var pageItem = function(p) {
            var href = $f5b7a22d3d3cc261$var$esc(p.link);
            var title = $f5b7a22d3d3cc261$var$esc(p.title);
            var cls = 'search-modal__suggestion-item';
            return '<li><a href="'.concat(href, '" class="').concat(cls, '">').concat(title, "</a></li>");
        };
        var productThumb = function(p) {
            var cls = 'search-modal__product-img';
            if (!p.thumbnail) return '<div class="'.concat(cls, " ").concat(cls, '--empty"></div>');
            var src = $f5b7a22d3d3cc261$var$esc(p.thumbnail);
            var alt = $f5b7a22d3d3cc261$var$esc(p.title);
            return '<img class="'.concat(cls, '" src="').concat(src, '" alt="').concat(alt, '">');
        };
        var productItem = function(p) {
            var href = $f5b7a22d3d3cc261$var$esc(p.link);
            var cls = 'search-modal__product-item';
            var infoCls = 'search-modal__product-info';
            var titCls = 'search-modal__product-title';
            var title = $f5b7a22d3d3cc261$var$esc(p.title);
            return [
                '<li><a href="'.concat(href, '" class="').concat(cls, '">'),
                productThumb(p),
                '<span class="'.concat(infoCls, '">'),
                '<span class="'.concat(titCls, '">').concat(title, "</span>"),
                '</span></a></li>'
            ].join('');
        };
        var renderResults = function(param) {
            var products = param.products, _param_suggestions = param.suggestions, suggestions = _param_suggestions === void 0 ? [] : _param_suggestions, _param_pages = param.pages, pages = _param_pages === void 0 ? [] : _param_pages, q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
            if (!resultsEl) return;
            var lblCls = 'search-modal__col-label';
            var listCls = 'search-modal__suggestion-list';
            var suggBlock = suggestions.length ? [
                '<p class="'.concat(lblCls, '">Suggestions</p>'),
                '<ul class="'.concat(listCls, '">'),
                suggestions.map(function(s) {
                    return suggItem(s, q);
                }).join(''),
                '</ul>'
            ].join('') : '';
            var pagesBlock = pages.length ? [
                '<p class="'.concat(lblCls, " ").concat(lblCls, '--pages">Pages</p>'),
                '<ul class="'.concat(listCls, '">'),
                pages.map(pageItem).join(''),
                '</ul>'
            ].join('') : '';
            var leftCol = suggestions.length || pages.length ? [
                '<div class="search-modal__left">',
                suggBlock,
                pagesBlock,
                '</div>'
            ].join('') : '';
            var productsBlock = products.length ? [
                '<p class="'.concat(lblCls, '">Products</p>'),
                '<ul class="search-modal__product-list">',
                products.map(productItem).join(''),
                '</ul>'
            ].join('') : '';
            var rightCol = [
                '<div class="search-modal__right">',
                productsBlock,
                '</div>'
            ].join('');
            resultsEl.innerHTML = [
                '<div class="search-modal__columns">',
                leftCol,
                rightCol,
                '</div>'
            ].join('');
            showDropdown();
        };
        var timer = null;
        var controller = null;
        var doSearch = function(q) {
            if (controller) controller.abort();
            controller = new AbortController();
            updateFooter(q);
            fetch("".concat(apiBase, "?q=").concat(encodeURIComponent(q)), {
                signal: controller.signal
            }).then(function(r) {
                return r.json();
            }).then(function(data) {
                return renderResults(data, q);
            }).catch(function() {
                hideDropdown();
            });
        };
        input === null || input === void 0 ? void 0 : input.addEventListener('input', function() {
            var q = input.value.trim();
            clearTimeout(timer);
            if (q.length < 3) {
                hideDropdown();
                return;
            }
            timer = setTimeout(function() {
                return doSearch(q);
            }, 300);
        });
        doc.addEventListener('click', function(e) {
            if (!modal.contains(e.target)) hideDropdown();
        }, {
            signal: signal
        });
        toggle.addEventListener('click', function() {
            return modal.classList.contains('is-open') ? closeModal() : open();
        });
        closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener('click', closeModal);
        clearBtn === null || clearBtn === void 0 ? void 0 : clearBtn.addEventListener('click', function() {
            if (input) {
                input.value = '';
                input.focus();
            }
            hideDropdown();
        });
        overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener('click', closeModal);
        doc.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') closeModal();
        }, {
            signal: signal
        });
    };
    var quoteBadge = function() {
        var badge = root.querySelector('#quote-badge');
        var countEl = root.querySelector('#quote-badge-count');
        if (!badge || !countEl) return;
        var STORAGE_KEY = 'kca_rfq_cart';
        var update = function() {
            try {
                var cart = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
                var total = cart.reduce(function(sum, i) {
                    return sum + (i.qty || 1);
                }, 0);
                if (total > 0) {
                    countEl.textContent = total;
                    badge.hidden = false;
                    badge.setAttribute('aria-hidden', 'false');
                } else {
                    badge.hidden = true;
                    badge.setAttribute('aria-hidden', 'true');
                }
            } catch (e) {
                badge.hidden = true;
            }
        };
        update();
        doc.defaultView.addEventListener('storage', function(e) {
            if (e.key === STORAGE_KEY) update();
        }, {
            signal: signal
        });
        doc.addEventListener('kca:cart:updated', update, {
            signal: signal
        });
        badge.addEventListener('click', function(e) {
            e.preventDefault();
            var modal = root.querySelector('#rfq-modal');
            if (modal) {
                modal.classList.add('is-open');
                modal.setAttribute('aria-hidden', 'false');
                doc.body.style.overflow = 'hidden';
            }
        });
    };
    var desktopDropdowns = function() {
        var items = root.querySelectorAll('.site-header__item.has-dropdown');
        var closeAll = function() {
            items.forEach(function(i) {
                var _i_querySelector;
                i.classList.remove('is-open');
                (_i_querySelector = i.querySelector('.site-header__chevron-btn')) === null || _i_querySelector === void 0 ? void 0 : _i_querySelector.setAttribute('aria-expanded', 'false');
            });
        };
        items.forEach(function(item) {
            var btn = item.querySelector('.site-header__chevron-btn');
            if (!btn) return;
            btn.addEventListener('click', function() {
                var isOpen = item.classList.contains('is-open');
                closeAll();
                if (!isOpen) {
                    item.classList.add('is-open');
                    btn.setAttribute('aria-expanded', 'true');
                }
            });
        });
        doc.addEventListener('click', function(e) {
            if (!e.target.closest('.site-header__item.has-dropdown')) closeAll();
        }, {
            signal: signal
        });
        doc.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') closeAll();
        }, {
            signal: signal
        });
    };
    var mobileDropdowns = function() {
        root.querySelectorAll('.site-nav-mobile__toggle').forEach(function(btn) {
            btn.addEventListener('click', function() {
                var _btn_closest;
                var open = btn.classList.contains('is-open');
                var sub = (_btn_closest = btn.closest('.site-nav-mobile__item')) === null || _btn_closest === void 0 ? void 0 : _btn_closest.querySelector('.site-nav-mobile__sub');
                root.querySelectorAll('.site-nav-mobile__toggle').forEach(function(b) {
                    var _b_closest_querySelector, _b_closest;
                    b.classList.remove('is-open');
                    b.setAttribute('aria-expanded', 'false');
                    (_b_closest = b.closest('.site-nav-mobile__item')) === null || _b_closest === void 0 ? void 0 : (_b_closest_querySelector = _b_closest.querySelector('.site-nav-mobile__sub')) === null || _b_closest_querySelector === void 0 ? void 0 : _b_closest_querySelector.classList.remove('is-open');
                });
                if (!open) {
                    btn.classList.add('is-open');
                    btn.setAttribute('aria-expanded', 'true');
                    sub === null || sub === void 0 ? void 0 : sub.classList.add('is-open');
                }
            });
        });
    };
    // Scroll-driven hiding is frontend-only; the preview header is static.
    if (!isEditor) sticky();
    hamburger();
    search();
    quoteBadge();
    desktopDropdowns();
    mobileDropdowns();
}
(0, $1MMdM.default)('header', $f5b7a22d3d3cc261$var$initHeader);

})();
//# sourceMappingURL=script.js.map
